import React from 'react';

// Static logo imports
import LogoDefault from '../../media/LOGO.png';
import LogoHorizontal from '../../media/dnzify-logo-black-horizontal.png';
import LogoBlanco from '../../media/dnzify-logo-white-horizontal.png'
import LogoBlack from '../../media/LOGO_BLACK.png'

export default function Logo({ handleNavigate }) {
  const handleClick = (e) => {
    e.preventDefault();
    handleNavigate('/');
  };

  return (
    <div className="nav-item-logo" onClick={handleClick}>
      <a href="https://www.dnzify.com" target="_blank" rel="noopener noreferrer">
        <img
          src={LogoBlack}
          alt="Dnzify Logo"
          style={{ marginTop: '0.5em', maxHeight: '40px', objectFit: 'contain' }}
        />
      </a>
    </div>
  );
}
